/**
 * Force Zod jitless under the dashboards' strict CSP — MUST be the first
 * import in `main.tsx`.
 *
 * Zod v4's `$ZodObjectJIT` evaluates its `allowsEval` probe (`new Function("")`)
 * at schema CONSTRUCTION time (`fastEnabled = !globalConfig.jitless &&
 * allowsEval.value`), not at parse time. Every module-level `z.object(...)` is
 * constructed while ES-module imports evaluate — i.e. BEFORE any statement in
 * `main.tsx`'s body runs. The previous fix called `z.config({ jitless: true })`
 * in the body of `main.tsx`, which was too late: the probe had already fired,
 * CSP blocked it (caught, harmless), and the browser emitted a
 * `securitypolicyviolation` that flooded RUM (7,499 `CSP: script-src blocked
 * eval` occurrences 2026-07-15 → 2026-09-23, source `index-*.js`).
 *
 * As a side-effect module imported first, this runs right after `zod` itself
 * evaluates and before any app/shared-package schema is constructed.
 * Never "fix" this by adding `'unsafe-eval'` to the CSP.
 */
import { z } from "zod";

z.config({ jitless: true });
